// extracted by mini-css-extract-plugin
export default {"selectorButton":"_1l1s77w","btnLink":"_1ms0wfv"};